var _path, _path2, _path3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTools(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_x37_88_x2C__Bulb_x2C__Internet_x2C__Internet_Of_Things_x2C__Iot_x2C__Wifi"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M251,50.998c-82.71,0-149.997,67.296-149.997,150.001c0,57.455,32.343,107.516,79.996,132.688v77.316 c0,5.519,4.478,9.991,10.001,9.991h119.999c5.523,0,10.001-4.473,10.001-9.991v-77.316 c47.663-25.182,80.001-75.243,80.001-132.688C401.001,118.293,333.71,50.998,251,50.998z M300.998,371h-99.997v-10.001h99.997V371 z M201.001,401.002v-10h99.997v10H201.001z M306.711,318.486c-3.491,1.653-5.713,5.169-5.713,9.034v13.478h-99.997v-13.478 c0-3.865-2.222-7.381-5.708-9.034C150.16,297.04,121,250.934,121,200.999c0-71.679,58.316-130,130-130s130,58.321,130,130 C381,250.934,351.839,297.04,306.711,318.486z",
    id: "id_101",
    style: {
      fill: "rgb(245, 44, 48)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M300.998,430.995h-99.997c-5.523,0-10.001,4.482-10.001,10c0,5.528,4.478,10.001,10.001,10.001h99.997 c5.523,0,10.001-4.473,10.001-10.001C310.999,435.478,306.521,430.995,300.998,430.995z",
    id: "id_102"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M281.002,460.997h-60c-5.528,0-10,4.482-10,10.001s4.472,10.001,10,10.001h60c5.519,0,9.996-4.482,9.996-10.001 S286.521,460.997,281.002,460.997z",
    id: "id_103"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M251,91c-60.657,0-109.999,49.347-109.999,109.999c0,5.523,4.478,10.001,9.996,10.001c5.528,0,10-4.478,10-10.001 c0-49.625,40.376-89.997,90.002-89.997s90.002,40.372,90.002,89.997c0,5.523,4.478,10.001,9.995,10.001 c5.523,0,10.001-4.478,10.001-10.001C360.998,140.347,311.651,91,251,91z",
    id: "id_104"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M222.716,232.715c-3.905,3.905-3.905,10.24,0,14.145c3.904,3.905,10.239,3.905,14.145,0 c7.794-7.799,20.484-7.799,28.284,0c3.904,3.905,10.234,3.905,14.139,0c3.905-3.905,3.905-10.24,0-14.145 C263.689,217.121,238.314,217.121,222.716,232.715z",
    id: "id_105",
    style: {
      fill: "rgb(219, 79, 114)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.504,211.503c-3.91,3.91-3.91,10.235,0,14.14c3.904,3.905,10.234,3.905,14.14,0c19.543-19.539,51.169-19.543,70.712,0 c3.905,3.905,10.235,3.905,14.14,0c3.91-3.905,3.91-10.235,0-14.14C273.143,184.146,228.861,184.146,201.504,211.503z",
    id: "id_106",
    style: {
      fill: "rgb(219, 79, 86)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.292,190.291c-3.905,3.905-3.905,10.235,0,14.14c3.904,3.91,10.235,3.91,14.14,0.005 c31.192-31.197,81.943-31.197,113.136,0c3.905,3.905,10.235,3.905,14.145-0.005c3.905-3.905,3.905-10.235,0-14.14 C282.721,151.299,219.279,151.304,180.292,190.291z",
    id: "id_107",
    style: {
      fill: "rgb(250, 15, 26)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.001,350.998c-16.545,0-30.002,13.458-30.002,30.003c0,16.535,13.457,30.002,30.002,30.002 c16.541,0,30.003-13.467,30.003-30.002C111.004,364.456,97.542,350.998,81.001,350.998z M81.001,391.002 c-5.518,0-10-4.493-10-10.001c0-5.519,4.482-10.001,10-10.001c5.514,0,10.001,4.482,10.001,10.001 C91.002,386.509,86.515,391.002,81.001,391.002z",
    id: "id_108",
    style: {
      fill: "rgb(18, 17, 18)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.001,91c16.54,0,29.997-13.457,29.997-30.002c0-16.54-13.457-29.997-29.997-29.997 c-16.546,0-30.003,13.457-30.003,29.997C360.998,77.543,374.455,91,391.001,91z M391.001,50.998c5.513,0,10,4.492,10,10 c0,5.519-4.487,10.001-10,10.001c-5.514,0-10.001-4.482-10.001-10.001C381,55.49,385.487,50.998,391.001,50.998z",
    id: "id_109",
    style: {
      fill: "rgb(20, 19, 20)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.998,300.994c-19.299,0-34.997,15.709-34.997,35.003c0,19.305,15.698,35.003,34.997,35.003 c19.3,0,35.003-15.698,35.003-35.003C461.001,316.703,445.298,300.994,425.998,300.994z M425.998,350.998 c-8.268,0-14.996-6.733-14.996-15.001s6.729-15.001,14.996-15.001c8.272,0,15.002,6.733,15.002,15.001 S434.271,350.998,425.998,350.998z",
    id: "id_110",
    style: {
      fill: "rgb(5, 5, 5)"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTools);
export default __webpack_public_path__ + "static/media/tools.9c511722b16c9c1aed7165ceb95ee39d.svg";
export { ForwardRef as ReactComponent };